export const COMERCIO_CORPORATIVO_LOGO_SRC =
  'https://files.tnonetwork.com/shows/logo/comerciocorporativo.png';
export const DARIO_ASCANIO_ANCHOR_SRC =
  'https://files.tnonetwork.com/users/profile/darioascanio.jpeg';
